import React from "react";

export default function CouponInfo() {
    return <div>CouponInfo</div>;
}
